import { ViewEncapsulation, Component, Input, OnInit, HostListener, EventEmitter, Output } from '@angular/core';
import { ModalService } from './modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnInit {

  @Input() modalId: string;
  @Input() closeIfOutside: boolean=false;
  @Output() onEnter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDismiss: EventEmitter<any> = new EventEmitter<any>();

  isOpen = false;

  @HostListener('keyup') onMouseEnter(event) {
    this.keyup(event);
  }

  constructor(private modalService: ModalService) {}

  ngOnInit() {
    this.modalService.registerModal(this);
    this.onEnter.emit();
  }

  close(modalId: string, checkBlocking? : boolean): void {
    if(!this.closeIfOutside) return;
    this.modalService.close(this.modalId, checkBlocking);
    this.onDismiss.emit();
  }

  private keyup(event: KeyboardEvent): void {
    if(event && event.keyCode===27) {
      this.modalService.close(this.modalId, true);
    }
  }

}